import { createContext, useContext, useState, type ReactNode } from 'react';

/**
 * Shared Filter Context
 * 
 * Stores filter state that should persist across different tabs/pages.
 */

interface FilterState {
  timeRange: string;
  setTimeRange: (value: string) => void;
}

const FilterContext = createContext<FilterState | null>(null);

export function FilterProvider({ children }: { children: ReactNode }) {
  const [timeRange, setTimeRange] = useState(''); // Empty = all time

  return (
    <FilterContext.Provider value={{ timeRange, setTimeRange }}>
      {children}
    </FilterContext.Provider>
  );
}

export function useFilters() {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error('useFilters must be used within a FilterProvider');
  }
  return context;
}

